var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"server-create-index"},[_c('page-header',{attrs:{"title":_vm.headerTitle,"tabs":_vm.cloudEnvOptions,"current-tab":_vm.cloudEnv},on:{"update:currentTab":function($event){_vm.cloudEnv=$event},"update:current-tab":function($event){_vm.cloudEnv=$event}}}),_c(_vm.component,{tag:"component",attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }